<template>
  <div class="client">
    <QueryForm @openAddClient="openAddClient" @advancedSearchhandleOk="advancedSearchhandleOk" @blurrySearch="blurrySearch"/>
    <TableList ref='tableList' :tableData="TableList" @pagChange="pagChange" @openEditClient="openEditClient" @delClient="delClient" />


    <a-modal :title="modalType?'添加客户':'修改客户'" v-model="visible" :footer="null" :maskClosable='false'>
      <a-form :form="form">
        <!-- 客户企业名称 -->
        <a-form-item
         v-bind="formItemLayout"
          label="客户名称">
          <a-input
            :maxLength="100"
            :disabled="editEnable"
            placeholder=""
            v-decorator="['name', {rules: [{ required: true, message: '请输入客户名称' }]} ]"
          />
        </a-form-item>
        <!-- 统一社会信用代码 -->
        <a-form-item
          v-bind="formItemLayout"
          label="组织机构码">
          <a-input
          
            :disabled="editEnable"
            :maxLength="18"
            placeholder=""
            v-decorator="['orgcode', { rules: [{ required: true, message: '请输入组织机构码' }],
             } ]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="地区选择" colon >
          <a-cascader 
            :options="cascaderOptions" 
            @change="regionOnChange" 
            :showSearch="{filter}" 
            placeholder="请选择地区"
            :value="regionVlaue"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="联系人" colon >
          <a-input :maxLength="30" v-decorator='["contacts"]'></a-input>
        </a-form-item>
        <a-form-item v-bind="formItemLayout" label="联系方式" colon >
          <a-input v-decorator='["user_phones",{ rules: [{validator:checkPhone }]}]'></a-input>
        </a-form-item>
      </a-form>

      <a-form-item :wrapper-col="{ span: 16, offset: 8 }">
        <a-button type="primary" style="margin-right:40px;" @click="resetFields"> 重置 </a-button>
        <!-- 新增提交 -->
        <a-button v-if="modalType" type="primary" :loading="handleloading" style="margin-right:40px;" @click="addHandleOk">提交</a-button>
        <!-- 编辑提交 -->
        <a-button v-else type="primary" :loading="handleloading" style="margin-right:40px;" @click="editHandleOk">提交</a-button>
      </a-form-item>
    </a-modal>
  </div>
</template>

<script>
import QueryForm from '@/components/users/client/QueryForm.vue'
import TableList from '@/components/users/client/TabList.vue'
import {invite,clientManage,editInvite,deleteUserDept} from '@/api/user'
import {checkSocialCode,checkPhone} from '@/utils'

export default {
  components: {QueryForm,TableList},
  data() {
    return {
      // 自定义校验 手机号
      checkPhone: (rule, value, callback) => {
        if(!value || value ==''){
          callback();
        } else if(value == 'admin'){
          callback();
        } else if (!/^1(3|4|5|6|7|8)\d{9}$/.test(value)){
          callback(new Error("请输入正确的手机号码"));
        } else{
          callback();
        }
      },
      formItemLayout:{
        labelCol: {
            span: 5
        },
        wrapperCol: {
            span: 17
        },
      },
      pagination: '',
      handleloading:false,
      modalType:true,  //true为新增   false为编辑
      loading:false,
      form: this.$form.createForm(this),
      visible: false,
      TableList:[],
      params: {
        enable:'',
        page:1,
        size:10,
        blurry:'',
        region:'',
      },
      blurry:'',
      editUserId:'',
      cascaderOptions:[],
      selectedRegion:'',
      regionVlaue:[],
      editEnable:'',
      certNum: '',
      reportNum: ''
    };
  },
  mounted() {
    this.clientManage()
    this.cascaderOptions = this.$province
  },
  methods: {
    /**
     *地区选择 
     */
    regionOnChange(value, selectedOptions){
      this.regionVlaue = value
      if(selectedOptions){
        let selectedLabel = []
        selectedOptions.filter(item => {
          selectedLabel.push(item.value)
        })
        this.selectedRegion = selectedLabel.join(',')
      }else{
        this.selectedRegion = ''
      }
    },
    /**
     * 实现地区搜索
     */
    filter(inputValue, path) {
      return path.some(
        option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
      );
    },
    check (rule, value, callback) {
      checkSocialCode(rule, value, callback)
    },
    blurrySearch(blurry){
      this.blurry = blurry
      this.clientManage()
    },

    // toggleType(type){
    //  if(type == 2){ // 已认证
    //     this.params.enable = 1
    //   }else if(type==3){ //未认证
    //     this.params.enable = 0
    //   }else {  // 其他  或者type为0则为查询全部
    //     this.params.enable = ''
    //   }
    //   // this.pagination.current = 1
    //   this.clientManage()
    // },
    advancedSearchhandleOk(params){
      if(params.state == '2'){ // 已认证
        this.params.enable = 1
      }else if(params.state == '3'){ //未认证
        this.params.enable = 0
      }else {  // 全部
        this.params.enable = ''
      }
      this.params.region = params.region
      this.clientManage()
    },
    editHandleOk(){
      let that = this
      try {
        that.form.validateFields((err,params) => {
          if(!err){
            let newRegionVlaue = ''
            if(this.regionVlaue.length>0){
              newRegionVlaue = this.regionVlaue.join(',')
            }else{
              newRegionVlaue = ''
            }

            // this.handleloading = true
            let clientParams = {
              type:2,  // 中介添加企业
              name:params.name,
              orgcode:params.orgcode,
              id:this.editUserId,
              userPhones:params.user_phones,
              contacts:params.contacts,
              region:newRegionVlaue
            }
            // this.handleloading = true
            this.editClient(clientParams)
          }
        })
      }catch(error){
        cosnole.log(error)
      }
    },
    addHandleOk() {
      this.form.validateFields((err,params) => {
        if(!err){
          this.handleloading = true
          let clientParams = {
            type:2, //中介添加客户
            name:params.name,
            orgcode:params.orgcode,
            userPhones:params.user_phones,
            contacts:params.contacts,
            region:this.selectedRegion
          }
          this.addClient(clientParams)
        }
      })
    },
    resetFields(){
      this.form.resetFields()
      this.regionVlaue = []
    },
    delClient(id){
      deleteUserDept(id).then(res => {
        let mod = (this.pagination.total - 1)%10  //余数为0页数减一
        let currentPage = Math.ceil((this.pagination.total - 1)/this.pagination.pageSize);
        if(mod == 0){ 
          if(this.pagination.current>1){
            if(this.pagination.current != currentPage){
              this.pagination.current--
            }
          } 
        }
        this.clientManage();
      }).catch(error=>{
        console.log("error",error)
      })
    },
    openEditClient(visible,params){
      // this.certNum = params.certNum
      // this.reportNum = params.reportNum
      if (!Boolean(params.enable) && params.certNum == 0 && params.reportNum == 0) {
        this.editEnable = false;
      } else {
        this.editEnable = true;
      }
      this.regionVlaue = params.region
      this.modalType= false
      this.visible = visible
      this.editUserId = params.id
      setTimeout(() => {
        this.form.setFieldsValue({
          name:params.name,
          orgcode:params.orgcode,
          contacts:params.contacts,
          user_phones:params.userPhones
        })
      },10)
    },
    openAddClient(visible){
      this.editEnable = false
      this.regionVlaue = []
      this.modalType = true
      this.visible = visible
      this.form.resetFields()
    },
    async addClient(params){
      try{
        let data = await invite(params)
        this.visible = false
        this.pagination.current =1
        this.handleloading = false
        this.clientManage()
      } catch (error){
        this.handleloading = false
        this.visible = false
        console.log(error)
      }
    },
    async editClient(params){
      try{
        let data = await editInvite(params)
        this.visible = false
        this.handleloading = false
        this.clientManage()
      } catch (error){
        this.handleloading = false
        this.visible = false
        console.log(error)
      }
    },
    async clientManage(){
      this.$refs.tableList.loading =true;
      this.pagination =  this.$refs.tableList.pagination;
      this.params.page = this.pagination.current-1
      this.params.size=this.pagination.pageSize
      this.params.blurry=this.blurry
      try{


        
        let data = await clientManage(this.params)
        this.TableList = data.content
        this.$refs.tableList.pagination.total = data.totalElements
        this.$refs.tableList.pagination.current = data.page
        this.$refs.tableList.pagination.pageSize = data.size
        this.$refs.tableList.loading =false;
      } catch (error) {
        console.log(error)
        this.$refs.tableList.loading =false;
      }
    },
    pagChange(){
      this.clientManage();
    },
    
    // checkPhone (rule, value, callback) {
    //   checkPhone(rule, value, callback)
    // },
  },
};
</script>

<style lang="less" scoped>
  .client{
    // padding: 15px;
  }
  .ant-form-item{
    margin-bottom:12px;
  }
</style>
